export default __webpack_public_path__ + "static/media/cabbage.53acdeb5.jfif";